import { Routes } from '@angular/router';
import { canDeactivateAppFn } from '@core/guards/app.guard';
import { modalGuard } from '@core/guards/modal.guard';
import { datasourcesLoaderResolverFn } from '../data-management/resolvers/datasources-loader.resolver';
import { routes as deploymentRoutes } from '../deployments-history/deployment-history.routes';
import { routes as environmentRoutes } from '../environments/environments.routes';
import { routes as pluginRoutes } from '../plugins/plugins.routes';
import { routes as pageRoutes } from '../page-management/pages.routes';
import { routes as sectionsRoutes } from '../sections-management/sections-management.routes';
import { routes as viewManagementRoutes } from '../view-management/view-management.routes';
import { widgetManagementRoutes } from '../widget-management/widget-management.routes';
import { AppResolverFn } from './resolvers/app.resolver';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import('./components/app-list/app-list.component').then(
				(component) => component.AppListComponent
			)
	},
	{
		path: ':appId',
		canDeactivate: [canDeactivateAppFn, modalGuard],
		data: { breadcrumb: (data: any) => `${data.app.name}` },
		resolve: { app: AppResolverFn, databases: datasourcesLoaderResolverFn },
		children: [
			{
				path: '',
				data: {},
				loadComponent: () =>
					import('./components/app-detail/app-detail.component').then(
						(component) => component.AppDetailComponent
					)
			},
			{
				path: 'app-access',
				data: { breadcrumb: 'APP_ACCESS.BREADCRUMBS.APP_ACCESS' },
				loadComponent: () =>
					import('./components/app-access/app-access.component').then(
						(component) => component.AppAccessComponent
					)
			},
			{
				path: 'pages',
				data: { breadcrumb: 'BREADCRUMBS.PAGES_LIST' },
				children: pageRoutes
			},
			{
				path: 'views',
				data: { breadcrumb: 'VIEWS.TITLES.LIST' },
				children: viewManagementRoutes
			},
			{
				path: 'widgets',
				children: widgetManagementRoutes
			},
			{
				path: 'navigation',
				data: { breadcrumb: 'BREADCRUMBS.SECTIONS_LIST' },
				children: sectionsRoutes
			},
			{
				path: 'security',
				data: { breadcrumb: 'SECURITY.BREADCRUMBS.MAIN' },
				loadComponent: () =>
					import('./components/security/security.component').then(
						(component) => component.SecurityComponent
					)
			},
			{
				path: 'plugins',
				data: { breadcrumb: 'SIDEBAR_MENU.LABELS.PLUGINS' },
				children: pluginRoutes
			},
			{
				path: 'environments',
				children: environmentRoutes
			},
			{
				path: 'deployments',
				children: deploymentRoutes
			}
		]
	}
];
